export type ShareSomeType = 'with-some';
export type ShareAllType = 'with-all-users' | 'with-all-and-new-users';

export interface IShareWithSomeUsers {
    type: ShareSomeType;
    shareWithUserIds: Array<string>;
}

export interface IShareWithAllUsers {
    type: ShareAllType;
}
